// SVG-пути навигационных иконок (внутренняя разметка <svg>). Вынесены из NavIcon.vue
// в отдельный модуль, чтобы `IconName` можно было импортировать в navigation.ts и
// типизировать поле `icon` у пунктов меню компилятором (а не строкой).
export const ICON_PATHS = {
  calendar: '<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18M8 2v4M16 2v4"/>',
  package: '<path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4"/>',
  user: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/>',
  bell: '<path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/>',
  users: '<circle cx="9" cy="8" r="3"/><path d="M2 21c0-3 3-5 7-5m5-9a3 3 0 0 1 0 6"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.3 1a7 7 0 0 0-1.7-1l-.3-2.5H9.4l-.3 2.5a7 7 0 0 0-1.7 1l-2.3-1-2 3.4L5 11a7 7 0 0 0 0 2l-2 1.5 2 3.4 2.3-1a7 7 0 0 0 1.7 1l.3 2.5h4.2l.3-2.5a7 7 0 0 0 1.7-1l2.3 1 2-3.4-2-1.5a7 7 0 0 0 .1-1z"/>',
  more: '<circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/>',
  'price-tag': '<path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7" cy="7" r="1"/>',
  wallet: '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><circle cx="17" cy="14" r="1.3"/>',
  logout: '<path d="M16 17l5-5-5-5M21 12H9M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4"/>',
  // Управляемый вход (спека 2026-08-23-door-access): дверное полотно + ручка-точка.
  door: '<rect x="5" y="2" width="14" height="20" rx="1"/><circle cx="15" cy="12" r="1"/>',
  // Пропуска (та же спека): ключ — кольцо-бородка + зубцы на бородке.
  key: '<circle cx="8" cy="8" r="3"/><path d="M10.1 10.1L20 20m-6-6l2-2m-6 6l2-2"/>',
  // Акции («Приведи друга», «Оставь отзыв»): подарочная коробка — крышка, тулово, лента.
  gift: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13"/><path d="M12 8S9.5 8 8.5 7a1.8 1.8 0 0 1 2.5-2.6c1 .7 1 3.6 1 3.6zm0 0s2.5 0 3.5-1a1.8 1.8 0 0 0-2.5-2.6c-1 .7-1 3.6-1 3.6z"/>',
  // Крестик закрытия (кнопка «Закрыть меню» в шторке «Ещё»).
  close: '<path d="M6 6l12 12M18 6L6 18"/>',
  // Зал (аренда актового зала): сцена — помост и портал.
  stage: '<path d="M3 20V9l9-5 9 5v11"/><path d="M3 20h18M8 20v-5h8v5"/>',
  // Отзывы о преподавателях: звезда.
  star: '<path d="M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.3l-5.8 3.1 1.1-6.5L2.6 9.3l6.5-.9z"/>',

  // Заявки на консультацию: облачко диалога.
  chat: '<path d="M21 12a8 8 0 0 1-11.6 7.1L3 21l1.9-5.4A8 8 0 1 1 21 12z"/>',

  // «Сегодня» владельца: дом — крыша и стены.
  home: '<path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/>',
} as const

export type IconName = keyof typeof ICON_PATHS
